/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {SynonymsInputMode} from './SynonymsInputMode';
import {Term} from './Term';
import {IdAndHeader} from './IdAndHeader';

export interface ProductSynonymsOperation {
  id?: number;
  includeTokens?: string;
  excludeTokens?: string;
  templateId?: number;
  template?: IdAndHeader;
  featureFilter?: { [key: number]: number[] };
  synonyms?: string;
  terms?: Term[];
  operationMode: number;
  synonymInputMode: SynonymsInputMode;
  enabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
}
